<template>

  <div class="container">


    <div v-if="!loaded" class="modal fade bd-example-modal-lg show d-block" data-backdrop="static" data-keyboard="false" tabindex="-1">
      <div class="modal-dialog modal-sm" >
          <div class="modal-content">
              <img alt="Trackd Music" src="../assets/trackd-loading.gif" height="50" class=" d-block mx-auto" />
          </div>
      </div>
    </div>

    <div v-if="loaded" class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3">

        <div v-if="account_type == 'chipin_account'" class="row">

          <b-alert v-if="external_account_needed || personal_information_needed" show variant="warning" class="mb-4 mx-3">
            <h5 class="alert-heading font-weight-light">Warning</h5>
            <p v-if="external_account_needed" class="alert-warning font-weight-light">
              Payouts are not enabled. <router-link v-if="access.bank_account" :to="{name: 'bank-account'}">Add a bank account</router-link> to enable payouts.
            </p>
            <p v-if="personal_information_needed" class="alert-warning mb-0 font-weight-light">
              Please click the "Manage Chipin Account Details" link below or <a v-if="access.chipin_management" :href="account_link">click here</a> to enable your account.
            </p>
          </b-alert>

          <!--<div class="col-6">
            <h5 class="mb-4 menu-dark font-weight-light">ChipIn Balance: {{ balance }}</h5>
          </div>-->

          <div class="col-6">
            <h5 class="mb-4 menu-dark text-center font-weight-light">Total: {{ total }}</h5>
          </div>

          <div class="col-6">
            <h5 class="mb-4 menu-dark text-center font-weight-light">Pending: {{ pending }}</h5>
          </div>

          <div class="col-12">
            <h5 class="mb-4 menu-dark text-center font-weight-light">In transit to bank: {{ in_transit }}</h5>
          </div>

          <!--
          <div class="col-6">
            <h5 class="mb-4 menu-dark font-weight-light">Cleared in Bank: {{ cleared }}</h5>
          </div>-->


          <div class="col-12" v-if="next_payment_date">
            <h6 class="mb-3 menu-dark text-center font-weight-light">Next payment date: {{ next_payment_date }}</h6>
          </div>

          <div v-if="payout_desc" class="col-12 text-center">
            <small class="font-weight-light mt-3 mb-3 text-center">*&nbsp;{{payout_desc}}</small>
          </div>

        </div>

        <div class="list-group mt-3">

          <router-link  v-if="access.transactions" :to="{name: 'transactions'}" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/transactions.png" alt="" class="mr-3 mb-1">
            Transactions
          </router-link>

          <router-link  v-if="access.subscriptions" :to="{name: 'subscriptions'}" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/subscriptions.png" alt="" class="mr-3 mb-1">
            Subscriptions
          </router-link>

          <router-link  v-if="access.payouts" :to="{name: 'payouts'}" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/transactions.png" alt="" class="mr-3 mb-1">
            Payout History
          </router-link>

          <!--
          <router-link :to="{name: 'payments'}" class="list-group-item list-group-item-action">
            Payments
          </router-link>
          -->
          <!--
          <router-link :to="{name: 'payments'}" class="list-group-item list-group-item-action">
            Payments
          </router-link>
          -->

          <router-link v-if="access.cards" :to="{name: 'cards'}" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/cards.png" alt="" class="mr-3 mb-1">
            Cards
          </router-link>

          <router-link v-if="access.bank_account" :to="{name: 'bank-account'}" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/bank-accounts.png" alt="" class="mr-3 mb-1">
            Bank Accounts
          </router-link>

          <a v-if="access.chipin_management" :href="account_link" class="list-group-item list-group-item-action menu-light font-weight-light pl-0 mb-1">
            <img src="../assets/icons/profile.png" alt="" class="mr-3 mb-1">
            Manage ChipIn Account Details
          </a>

      </div>

    </div>
    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'Account',
  data() {
    return  {
      loaded: false,
      access: null,
      account_type: null,      
      pending: "0.00",
      balance: "0.00",
      in_transit: "0.00",
      total: "0.00",
      cleared: "0.00",
      next_payment_date: null,
      account_link: null,
      payout_enabled: false,
      payout_desc: null,
      account_disabled: false,
      account_verified: false,
      external_account_needed: false,
      personal_information_needed: false
    }
  },
  methods: {
    loadData () {

      let token = null;

      try {
        token = this.$store.getters.getToken.access
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }

      console.log(token)

      //localStorage.getItem('accessToken')
      let headers = {
        'Authorization': 'JWT ' + token
      }

      axios.get('/chipin/account/details/', {'headers': headers})
          .then(res => {
            console.log(res.data)
            this.pending = res.data.pending
            this.balance = res.data.available
            this.cleared = res.data.cleared
            this.total = res.data.total
            this.in_transit = res.data.in_transit
            this.next_payment_date = res.data.next_payment_date
            this.account_link = res.data.account_link
            this.account_type = res.data.account_type
            this.access = res.data.access
            
            this.payout_enabled = res.data.payout_enabled
            this.payout_desc = res.data.payout_desc
            this.account_disabled = res.data.account_disabled
            this.account_verified = res.data.account_verified
            this.personal_information_needed = res.data.personal_information_needed
            this.external_account_needed = res.data.external_account_needed

            this.$store.dispatch('storeStripeType', res.data.stripe_account_type)

            localStorage.setItem('StripeType', res.data.stripe_account_type)
            
            this.loaded = true
          })
          .catch(error => {
            this.name = 'Sorry something went wrong!';
            console.log(error)
          });

    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>

<style lang="css">

  .list-group-item {
    border: none;
    border-bottom: 1px solid #DBDADA;
  }
 
</style>